import { EditNew16, View16 } from 'ui/icons';
import { LargeSegmentedControl, SEGMENTED_CONTROL_VARIANTS } from 'ui/segmentedControl';

import { MessageMedium } from 'modules/domains/campaign';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { InAppContentDefinition, MESSAGE_FORMAT } from 'modules/graphql/types';
import { useTemplateQueryContext } from '../../context/TemplateQueryContext';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { displayContent } from '../content';
import { TemplateEditViews } from '../types';
import { DISABLED_DESIGN_BUTTON_TEXT } from '../constants';

export const ViewSwitchToggle = ({ variant }: { variant?: SEGMENTED_CONTROL_VARIANTS }) => {
  const { setView, view } = useQueryParamContext();
  const { medium } = useTemplateQueryContext();
  const { liveTemplate } = useEditableFieldsContext();
  const hasSwitchToggle = medium === MessageMedium.Email || medium === MessageMedium.InApp;
  const { mediumData } = liveTemplate || {};
  const { messageFormat } = mediumData as InAppContentDefinition;
  const isJsonOnly = messageFormat === MESSAGE_FORMAT.Json;

  if (!hasSwitchToggle) return null;

  return (
    <LargeSegmentedControl
      onSelect={setView}
      options={[
        {
          key: 'option-edit-content',
          Icon: EditNew16,
          name: displayContent.btnDesign,
          value: TemplateEditViews.content,
          disabled: isJsonOnly,
          ...(isJsonOnly && {
            tooltip: {
              content: DISABLED_DESIGN_BUTTON_TEXT,
            },
          }),
        },
        {
          key: 'option-edit-preview',
          Icon: View16,
          name: displayContent.btnPreview,
          value: TemplateEditViews.preview,
        },
      ]}
      value={view}
      variant={variant}
    />
  );
};

export default ViewSwitchToggle;
